import type { ReactNode } from "react";

interface NavItem {
  label: string;
  icon: ReactNode;
  activeIcon?: ReactNode;
  active?: boolean;
  onClick?: () => void;
}

interface BottomNavProps {
  items: NavItem[];
}

export function BottomNav({ items }: BottomNavProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-ios-header backdrop-blur-md border-t border-ios-separator/50">
      <div className="flex items-center justify-around h-16 pb-1">
        {items.map((item, idx) => (
          <button
            key={idx}
            onClick={item.onClick}
            className={`flex flex-col items-center justify-center gap-1 w-16 h-full transition ${
              item.active ? "text-ios-primary" : "text-ios-tertiary"
            }`}
          >
            {item.active && item.activeIcon ? item.activeIcon : item.icon}
            <span className="text-[10px] font-semibold">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
